/**
 * DashboardCard Component
 * Presentational component for displaying dashboard stats
 */
export interface DashboardCardProps {
  title: string;
  value: string | number;
  subtitle?: string;
}

export const DashboardCard = ({ title, value, subtitle }: DashboardCardProps) => {
  return (
    <div>
      <h3>{title}</h3>
      <p>{value}</p>
      {subtitle && <p>{subtitle}</p>}
    </div>
  );
};
